import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  startHour: 8,
  endHour: 20,
  calendarView: null,
  showWeekends: false,
};

const slice = createSlice({
  name: 'calendarSettings',
  initialState,
  reducers: {
    setStartHour: (state, action) => ({
      ...state,
      startHour: action.payload,
    }),
    setEndHour: (state, action) => ({
      ...state,
      endHour: action.payload,
    }),
    setShowWeekends: (state, action) => ({
      ...state,
      showWeekends: action.payload,
    }),
     setCalendarView: (state, action) => ({
      ...state,
      calendarView: action.payload,
     }),
  }
});

export const {
  setStartHour,
  setEndHour,
  setShowWeekends,
  setCalendarView,
} = slice.actions;
    
export default slice.reducer;